// extracted by mini-css-extract-plugin
export default {"item":"Service_item__bcMig","icon-container":"Service_icon-container__JmZGN","title":"Service_title__HWbpc","desc":"Service_desc__UT91i"};